export default "__VITE_ASSET__CdKz5zWr__"